export const sanitizeDialPart = (value) => {
  return String(value ?? "").replace(/\D/g, "");
};

export const buildWhatsAppTestUrl = ({ countryCode, phoneNumber } = {}) => {
  const countryCodeDigits = sanitizeDialPart(countryCode);
  const phoneDigits = sanitizeDialPart(phoneNumber);

  if (!countryCodeDigits || !phoneDigits) {
    return null;
  }

  return `https://wa.me/+${countryCodeDigits}${phoneDigits}`;
};

export const getWhatsAppTestPayload = (agent) => {
  const countryCodeDigits = sanitizeDialPart(
    agent?.provider_settings?.country_code,
  );
  const phoneDigits = sanitizeDialPart(agent?.provider_settings?.phone_number);
  const waUrl = buildWhatsAppTestUrl({
    countryCode: countryCodeDigits,
    phoneNumber: phoneDigits,
  });

  return {
    countryCodeDigits,
    phoneDigits,
    waUrl,
    isReady: Boolean(waUrl),
  };
};
